// in EPSG:3587
const CENTER = [3320171.507422322, -216020.61782066917];
const ZOOM = 8;

const view = uc => {
    return {
        center: uc.center ? uc.center : CENTER,
        zoom: uc.zoom ? uc.zoom : ZOOM,
    };
};

export default {
    view,
};



// WEBPACK FOOTER //
// ./resources/assets/js/src/maps/defaultConfig.js